import * as React from 'react';
import { ReactNode } from 'react';
import { ButtonModifier } from './helpers';

interface IAlertButtonProps {
    handler?: () => void;
    text?: string | object | ReactNode;
    modifier?: ButtonModifier;
    disableClickHandlerForOverlay?: boolean;
    hideCloseButtonInAlertPopup?: boolean;
}

interface IAlertPropsWithoutButtons {
    className?: string;
    message: string | React.ReactNode;
    title?: string | React.ReactNode;
    /**
     * by default cross icon is not rendered as OK button acts as close handler
     */
    renderCrossIcon?: boolean;
}

interface IAlertProps extends IAlertPropsWithoutButtons {
    okButtonProps?: IAlertButtonProps;
}

interface INotificationProps {
    message: string | JSX.Element;
    statusCode?: number;
    alignment?: string;
    withCloseIcon?: boolean;
    isRelatedToEvent?: boolean;
}

interface IConfirmProps extends IAlertPropsWithoutButtons {
    confirmButtonProps?: IAlertButtonProps;
    extendConfirmButtonProps?: IAlertButtonProps;
    cancelButtonProps?: IAlertButtonProps;
}

/**
 * Provide api, similar to built-in browser alert() and confirm() functions but inside the custom styled windows.
 * Must be used if alert is to be triggered as a result of some activity.
 *
 * If particular UI view should be shown in modal window - use CommonModal instead of this service.
 */
abstract class IAlertsService {
    public abstract alert(alertProps: IAlertProps) : string;
    public abstract confirm(confirmProps: IConfirmProps) : string;
    public abstract closeAlert(alertKey: string): void;
    public abstract notification(notificationProps: INotificationProps) : string;
    public abstract closeNotification(alertKey: string): void;
    public abstract closeEventNotifications(): void;
}

export { IAlertsService, IAlertProps, IConfirmProps, IAlertButtonProps, INotificationProps };
